// src/components/ui/Badges.tsx

import React from "react";
import { CouponStatus, PaymentStatus } from "../../types";

export const PLAN_LABEL: Record<PaymentStatus, string> = {
  gratuito: "Prueba gratuita",
  pagado: "Premium",
  cupon: "Cupón",
  cancelado: "Cancelado",
  pendiente: "Pago pendiente",
};

export const COUPON_STATUS_LABEL: Record<CouponStatus, string> = {
  ACTIVO: "Activo",
  INACTIVO: "Inactivo",
  VENCIDO: "Vencido",
  AGOTADO: "Agotado",
  PROGRAMADO: "Programado",
};

export function AccountBadge({ enabled }: { enabled: boolean }) {
  return (
    <span className={`badge-estado badge-${enabled ? "ACTIVA" : "INACTIVA"}`}>
      <i
        className={`bi ${enabled ? "bi-check-circle-fill" : "bi-slash-circle"}`}
      />
      {enabled ? "Activa" : "Inactiva"}
    </span>
  );
}

export function PlanBadge({
  status,
}: {
  status: PaymentStatus | string | null | undefined;
}) {
  const key = (status ?? "").toLowerCase() as PaymentStatus;
  const label = PLAN_LABEL[key];
  if (!label) {
    return (
      <span className="badge-estado badge-SIN_PLAN">
        {status || "Sin plan"}
      </span>
    );
  }
  return <span className={`badge-estado badge-${key}`}>{label}</span>;
}

export function CouponStatusBadge({ status }: { status: CouponStatus }) {
  return (
    <span className={`badge-estado badge-${status}`}>
      {COUPON_STATUS_LABEL[status] ?? status}
    </span>
  );
}
